var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeli(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.07,35.58L87.59,7.07l-3.46-3.46L58.02,29.72c-0.93-2.68-3.72-9.46-8.17-9.46c-4.45,0-7.24,6.78-8.17,9.46L15.56,3.61 L12.1,7.07l28.51,28.51v11.53L12.1,75.63l3.46,3.46l27.07-27.07c0.47,0.65,0.98,1.31,1.5,1.97c0.42,0.54,0.84,1.08,1.23,1.61 c0.5,0.67,0.93,1.32,1.33,1.93l0.29,0.43l0.28,22.18h-2.19l-4.71,1.31v5.54l4.75,0.27h2.24l0.12,9.06h4.74l0.12-9.06l2.33,0 l4.66-0.27v-5.54l-4.48-1.27l-2.42-0.03l0.28-21.87c0.36-0.48,0.74-1.02,1.16-1.62c0.27-0.39,0.56-0.8,0.87-1.23 c0.25-0.34,0.5-0.69,0.76-1.05c0.55-0.75,1.11-1.52,1.63-2.28l27.01,27l3.46-3.46L59.07,47.12V35.58z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.06,47.42h0.02V35.17l28.1-28.1l-2.05-2.05L57.55,31.59c-1.17-4.32-4.18-10.34-7.71-10.34 c-3.53,0-6.54,6.02-7.71,10.34L15.56,5.02l-2.05,2.05l28.1,28.1v12.26h0.02c0,0.03-0.01,0.07-0.01,0.1L13.52,75.63l2.05,2.05 l27.21-27.21c0.94,1.44,2.29,3.04,3.39,4.53c0.72,0.97,1.3,1.9,1.81,2.65l0.3,23.49h-3.2l-3.71,1.06v3.84l3.75,0.21h3.23l0.12,9.06 h2.76l0.12-9.06h3.26l3.72-0.21V82.2l-3.76-1.06h-3.16l0.3-23.21c0.64-0.82,1.36-1.9,2.21-3.09c1.01-1.4,2.19-2.94,3.03-4.33 l27.17,27.17l2.05-2.05L58.06,47.52C58.06,47.49,58.06,47.46,58.06,47.42z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeli);
export default __webpack_public_path__ + "static/media/heli.498e0ca2.svg";
export { ForwardRef as ReactComponent };